(() => {
  const roots = document.querySelectorAll('[data-neo-video-root]');

  roots.forEach((root) => {
    root.querySelectorAll('[data-youtube-thumbnail]').forEach((image) => {
      image.addEventListener('error', () => {
        const fallback = image.dataset.fallbackSrc;
        if (!fallback || image.src === fallback) return;
        image.src = fallback;
      }, { once: true });
    });

    root.querySelectorAll('[data-video-player]').forEach((button) => {
      button.addEventListener('click', () => {
        const videoId = button.dataset.videoId;
        if (!videoId) return;
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
        iframe.title = button.dataset.videoTitle || 'NEOPPF video';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.loading = 'eager';
        button.replaceWith(iframe);
      }, { once: true });
    });

    const cards = Array.from(root.querySelectorAll('[data-video-browse-card]'));
    const filterButtons = Array.from(root.querySelectorAll('[data-video-filter]'));
    const resultText = root.querySelector('[data-video-results]');
    if (!cards.length || !filterButtons.length) return;

    const libraryGrid = cards[0]?.parentElement;
    if (libraryGrid) {
      cards
        .sort((a, b) => String(b.dataset.publishDate || '').localeCompare(String(a.dataset.publishDate || '')))
        .forEach((card) => libraryGrid.append(card));
    }

    const applyFilter = (button, { scroll = true } = {}) => {
      const category = button.dataset.category || '';
      const intent = button.dataset.intent || '';
      let visible = 0;

      cards.forEach((card) => {
        const matchesCategory = !category || card.dataset.category === category;
        const matchesIntent = !intent || card.dataset.intent === intent;
        const show = matchesCategory && matchesIntent;
        card.hidden = !show;
        if (show) visible += 1;
      });

      filterButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      if (resultText) resultText.textContent = `${visible} video${visible === 1 ? '' : 's'} shown`;
      if (scroll) root.querySelector('#all-videos')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    filterButtons.forEach((button) => button.addEventListener('click', () => applyFilter(button)));

    const requestedCategory = new URLSearchParams(window.location.search).get('category');
    if (requestedCategory) {
      const initialButton = filterButtons.find((button) => button.dataset.category === requestedCategory);
      if (initialButton) applyFilter(initialButton, { scroll: false });
    }
  });
})();
